<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';
    import { fetchTransporte, saveTransporte, removeTransporte, searchTransportes, subscribeToTransportes, unsubscribeFromTransportes } from '../controllers/transporteController.js';
    import { fetchUsers } from '../controllers/userController.js'; // Function to load users

    // Configuration for the transporte table columns
    let transporteColumns = [
        { label: $t('fields.description'), field: 'descrip', type: 'text' },
        { label: $t('fields.phone'), field: 'telefono', type: 'text' },
        { label: 'Email', field: 'email', type: 'text' },
        { label: $t('fields.state'), field: 'sta', type: 'bool' },
    ];

    // Structure for a new transporte object
    let newTransporte = {
        descrip: '',
        telefono: '',
        email: '',
        sta: true,
        user: '', // Optional: Link to a user if needed
    };

    // Configuration for the edit form fields
    let editColumns = [
        { label: $t('fields.description'), key: 'descrip', type: 'text', required: true },
        { label: $t('fields.phone'), key: 'telefono', type: 'text', required: true },
        { label: 'Email', key: 'email', type: 'text', required: true },
        { label: $t('fields.state'), key: 'sta', type: 'checkbox', required: true },
    ];

    // Load users when the component mounts
    onMount(() => {
    });
</script>

<CRUD 
    title={$t('entities.transportes')}
    entityName="transporte"
    newEntity={newTransporte}
    columns={transporteColumns}
    fetchEntities={fetchTransporte}
    saveEntity={saveTransporte}
    removeEntity={removeTransporte}
    searchEntities={searchTransportes}
    subscribeToChanges={subscribeToTransportes}
    unsubscribeFromChanges={unsubscribeFromTransportes}
    editColumns={editColumns}
/>